import { useStandortContext } from '@/features/standortContext/StandortContext';
import { getSessionTokens } from '@/services/auth/authentication';
import { Datev } from '@e2n/datev';

// Must be rendered below AuthorizedPage since useStandortContext needs StandortContextProvider.
export function DatevRoute() {
  const { currentStandort } = useStandortContext();

  return (
    <Datev
      getAccessToken={async () =>
        (await getSessionTokens())?.accessToken.toString()
      }
      standort={{ id: currentStandort.uid, name: currentStandort.name }}
    />
  );
}
